import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconsModule, UiComponentsModule } from '@fcom/ui-components';
import { CmsModule } from '@fcom/cms/components';
import { ComponentsModule, DirectiveModule, PipesModule } from '@fcom/common';
import { QualtricsModule } from '@fcom/common/qualtrics/qualtrics.module';
import { OrderApiModule } from '@fcom/dapi/api/order-api.module';
import { LocalizationProvider } from '@fcom/core/services/language/localization.provider';
import { CommonBookingComponentsModule } from '@fcom/common-booking/common-booking.module';
import { BookingOrderService, CommonBookingAncillariesModule } from '@fcom/common-booking';
import {
  CommonBookingPurchaseSuccessModule,
  PurchaseSuccessService,
} from '@fcom/common-booking/modules/purchase-success';
import { GtmModule } from '@fcom/common/gtm';
import { I18nKey } from '@fcom/core';

import { BookingCommonModule } from '../common/booking-common.module';
import { PurchaseSuccessComponent } from './components/purchase-success/purchase-success.component';
import { BookingPurchaseSuccessRouteComponent } from './routes/booking-purchase-success-route.component';
import { PurchaseSuccessGuard } from './services/purchase-success.guard';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    BookingCommonModule,
    CommonBookingComponentsModule,
    CommonBookingAncillariesModule,
    CommonBookingPurchaseSuccessModule,
    CmsModule,
    QualtricsModule,
    PipesModule,
    UiTranslateModule,
    IconsModule,
    OrderApiModule,
    UiComponentsModule,
    DirectiveModule,
    GtmModule,
  ],
  declarations: [BookingPurchaseSuccessRouteComponent, PurchaseSuccessComponent],
  exports: [BookingPurchaseSuccessRouteComponent],
  providers: [BookingOrderService, PurchaseSuccessGuard, PurchaseSuccessService],
})
export class PurchaseSuccessModule {
  constructor(private localizationProvider: LocalizationProvider) {
    // TODO: Should we move the lazy mmb localization to booking localizations, so no need to load mmb here
    this.localizationProvider.triggerLazyLocalizations(I18nKey.MMB);
  }
}
